import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import React from 'react';
import StyledWithItem from './Item';
import css from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var StyledWith = function StyledWith(_ref) {
  var styledWith = _ref.styledWith;
  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("div", {
      className: css.title,
      children: ["Styled With", /*#__PURE__*/_jsx("span", {
        className: css.desktop,
        children: ":"
      })]
    }), /*#__PURE__*/_jsx("ul", {
      className: css.list,
      children: styledWith.map(function (item) {
        return /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsx(StyledWithItem, _objectSpread({}, item))
        }, item.image.id);
      })
    })]
  });
};

StyledWith.propTypes = {
  styledWith: PropTypes.arrayOf(PropTypes.shape(_objectSpread({}, StyledWithItem.propTypes))).isRequired
};
export default StyledWith;